import React from "react";
import { Col, Anchor, Button } from "antd";
import "./welcomeLeft.css";

const { Link } = Anchor;

const WelcomeLeft = () => {
  return (
    <Col className="col1" value={100} span={12}>
      <h1 className="head1">
        <strong>PubMedSearch</strong> - сервис для поиска медицинских
        исследований.
      </h1>
      <Anchor affix={false} bounds="10" className="anchor">
        <Link href="#fq" title="Что это за приложение?" />
        <Link href="#sq" title="Как им пользоваться?" />
        <Link className="wrap" href="#one" title="Войдите с помощью Google." />
        <Link href="#two" title="Примеры поисковых запросов.">
          <Link href="#keys" title="По ключевым словам" />
          <Link href="#fullName" title="Полным названиям исследований" />
          <Link href="#DOI" title="DOI" />
          <Link href="#id" title="PMID/PMCID" />
        </Link>
      </Anchor>
      <Button
        href="https://github.com/asdwe23901/medartseach"
        type="primary"
        icon="github"
        className="github"
      >
        GitHub
      </Button>
    </Col>
  );
};

export default WelcomeLeft;
